import { defineStore } from "pinia";

export interface RouterHelperState {
  isFirstRequest: boolean;
  displayBackButton: boolean;
  showQuestionnaireProgressBar: boolean;
}

export const useRouterHelper = defineStore("routerHelper", {
  state: (): RouterHelperState => ({
    isFirstRequest: true,
    displayBackButton: false,
    showQuestionnaireProgressBar: false,
  }),
  actions: {
    changeStateAfterFirstRequest(): void {
      this.isFirstRequest = false;
    },
  },
});
